import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "../lib/api";
import { plur } from "../lib/localize";
import { useCart } from "../context/CartContext";
import { useLang } from "../i18n/LanguageContext";
import { SEO } from "../components/SEO";

// Lien magique du courriel de rappel : remet les articles d'une commande passée dans le panier.
export default function Reorder() {
  const { orderId } = useParams();
  const { add } = useCart();
  const { lang } = useLang();
  const navigate = useNavigate();
  const [error, setError] = useState("");

  useEffect(() => {
    api.get(`/orders/${orderId}/reorder`)
      .then((r) => {
        r.data.items.forEach((i) => add(i));
        toast.success(lang === "fr"
          ? `${plur(r.data.items.length, "article")} remis dans votre panier`
          : `${r.data.items.length} ${r.data.items.length === 1 ? "item" : "items"} added back to your cart`);
        navigate("/panier", { replace: true });
      })
      .catch((e) => setError(formatApiError(e.response?.data?.detail)));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderId]);

  return (
    <div data-testid="reorder-page" className="min-h-[60vh] flex flex-col items-center justify-center px-6 pt-24 pb-16 text-center">
      <SEO title={lang === "fr" ? "Recommander | Mr Trophée" : "Reorder | Mr Trophée"} description="" path={`/recommande/${orderId}`} noindex />
      {error ? (
        <>
          <p className="font-serif text-3xl mb-4" data-testid="reorder-error">
            {lang === "fr" ? "Impossible de recommander" : "Unable to reorder"}
          </p>
          <p className="text-ivory/60 text-sm mb-8">{error}</p>
          <Link to="/compte" data-testid="reorder-account-link"
            className="inline-flex items-center gap-2 bg-gold text-ink font-semibold px-8 py-3.5 rounded-full hover:bg-champagne transition-colors duration-300">
            {lang === "fr" ? "Voir mes commandes" : "View my orders"}
          </Link>
        </>
      ) : (
        <>
          <Loader2 className="w-8 h-8 text-gold animate-spin mb-6" />
          <p className="text-ivory/70" data-testid="reorder-loading">
            {lang === "fr" ? "Nous remettons vos articles dans votre panier…" : "Putting your items back in your cart…"}
          </p>
        </>
      )}
    </div>
  );
}
